<template>
  <div class="background-image" :class="classes">
      <svg
        width="214"
        height="135"
        viewBox="0 0 214 135"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g style="mix-blend-mode: luminosity">
          <path
            d="M178.292 25.7387V17.8692C178.292 9.69217 172.905 2.25197 165.011 0.477769C162.483 -0.132447 159.851 -0.158465 157.311 0.401651C154.771 0.961767 152.39 2.09359 150.343 3.71283C148.296 5.33207 146.637 7.39702 145.49 9.75392C144.342 12.1108 143.736 14.6989 143.715 17.3255V25.7387H178.292Z"
            fill="#554E4E"
            fill-opacity="0.05"
          />
          <path
            d="M143.715 79.0393V199.37C143.715 207.547 149.103 214.988 156.997 216.769C159.528 217.38 162.163 217.405 164.706 216.843C167.248 216.28 169.632 215.145 171.679 213.52C173.726 211.896 175.383 209.826 176.527 207.463C177.671 205.101 178.272 202.508 178.285 199.878V79.0393H143.715Z"
            fill="#554E4E"
            fill-opacity="0.05"
          />
          <path
            d="M25.4897 34.9119H17.8153C9.15679 34.9119 1.41866 41.1216 0.186793 49.7922C-0.1774 52.2754 -0.00772133 54.8088 0.684273 57.2198C1.37627 59.6307 2.57432 61.8627 4.19685 63.7636C5.81937 65.6645 7.82826 67.1898 10.0867 68.2355C12.3451 69.2813 14.8001 69.8229 17.2843 69.8235H25.4897V34.9119Z"
            fill="#554E4E"
            fill-opacity="0.05"
          />
          <path
            d="M78.2267 34.9119V69.845H195.75C204.415 69.845 212.154 63.6353 213.393 54.9718C213.756 52.4882 213.585 49.9547 212.892 47.5437C212.199 45.1328 211 42.901 209.377 41.0002C207.754 39.0994 205.745 37.5743 203.486 36.5286C201.228 35.4829 198.772 34.9413 196.288 34.9405L78.2267 34.9119Z"
            fill="#554E4E"
            fill-opacity="0.05"
          />
          <path
            d="M69.138 137.864V19.0135C69.138 10.8436 63.7574 3.39626 55.8635 1.61491C53.3318 1.0039 50.6961 0.978702 48.1534 1.54119C45.6106 2.10368 43.2265 3.23933 41.1789 4.86334C39.1314 6.48736 37.4733 8.55778 36.3285 10.92C35.1838 13.2823 34.5819 15.8753 34.5677 18.5056L34.5677 137.864H69.138Z"
            fill="#554E4E"
            fill-opacity="0.05"
          />
        </g>
      </svg>
    </div>
</template>
<script>
export default {
    name: "BackgroundImage",
    props: {
        classes: String,
    }
}
</script>
<style lang="scss">
.background-image {
    position: absolute;
    bottom: 0;
}
</style> 